/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var app          = require('mag-app'),
    systemPlayer = require('./system.player');


app.timeshift.addListener('buffer:pause:full', function () {
    systemPlayer.primary.position = 12;
    systemPlayer.primary.resume();
});

app.timeshift.addListener('buffer:full', function () {
    var position;

    if ( app.timeshift.cyclic ) {
        position = systemPlayer.primary.position;
        systemPlayer.primary.position = position;
        core.notify({
            title: gettext('Timeshift buffer is full'),
            icon: 'alert',
            timeout: 3000
        });
    }
});

app.timeshift.addListener('buffer:almost:full', function () {
    core.notify({
        title: gettext('1 minute before timeshift buffer turns full'),
        icon: 'alert',
        timeout: 3000
    });
});

app.timeshift.addListener('storage:unavailable', function () {
    core.notify({
        title: gettext('USB storage unavailable'),
        icon: 'alert',
        timeout: 3000
    });
});


app.timeshift.addListener('storage:full', function () {
    core.notify({
        title: gettext('USB storage is full'),
        icon: 'alert',
        timeout: 3000
    });
});
